module.exports = {"defaultLocation":"39.8573462,-4.1260612","typedLength":3,"placeholder":"Introduce tu dirección. Ej: Mayor, 3  Madrid","noResults":" Google Maps no encuentra la dirección. Introduce calle, nº, localidad (sin piso, ni puerta).","numberPlaceHolder":"Nº o SN","searchTimeout":300,"maxResults":5,"apiUrl":"https://pro-repsol.ed-integrations.com/v1"}


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/defaultConfig/config.json
// module id = Hd4J
// module chunks = 1